import Field from './field';

const JS_LABEL = '[js-label]';
const JS_VALIDATION_TYPE = 'js-validation-type';
const JS_LANGUAGE = 'js-language';

class ValidationType extends Field {
    constructor(form, error, element) {
        super();
        this.form = form;
        this.element = element;
        this.error = error;

        this.field = this.getFields(this.element)[0];
        this.language = this.form.getAttribute(JS_LANGUAGE);
        this.checkValidationType();
    }
    
    validationMessage(labelText) {
        switch(this.language) {
            case 'nl':
                return `Dit is geen geldige waarde voor het '${labelText.replace('*','').trim()}' veld.`;
            case 'en':
                return `This is not a valid value for the '${labelText.replace('*','').trim()}' field.`;
            case 'de':
                return `Dies ist kein gültiger Wert für das Feld '${labelText.replace('*','').trim()}'.`;
            case 'es':
                return `Este no es un valor válido para el campo '${labelText.replace('*','').trim()}'.`;
            case 'fr':
                return `Ce n'est pas une valeur valide pour le champ '${labelText.replace('*','').trim()}'.`;
            default:
                return `This is not a valid value for the '${labelText.replace('*','').trim()}' field.`;
        }
    }

    checkValidationType() {
        
        const validationType = this.element.getAttribute(JS_VALIDATION_TYPE);
        const labelText = this.element.querySelector(JS_LABEL).innerText;
        const message = this.validationMessage(labelText);

        let hasError = this.hasValue(this.field) && !this.getRegex(validationType).test(this.field.value) ? true : false;
        this.error.errorData(hasError, `validation-type`, this.field, this.element, message);
    }

    getRegex(sort) {
        let validation;
        
        switch (sort){
            case 'phone':
                validation = /^((\s|[\.\-\+\(\)\[\]])*[0-9]){6,14}$/;
            break;
            case 'email':
                validation = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            break;
            case 'euro':
                validation = /^[0-9.]+(\,[0-9]{1,2})?$/;
            break;
            default:
                validation = false;
            break;
        }
        return validation;
    }
}

export default ValidationType;
